import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h48v48H0z", fill: "none" }), /* @__PURE__ */ React.createElement("path", { d: "M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm2 30h-4V22h4v12zm0-16h-4v-4h4v4z", fill: "#5082c2", className: "fill-000000" }));
const ForwardRef = forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
